import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss'
})
export class NoDataComponent {
  @Input() noData?: boolean = false;
  @Input() showImage?: boolean = true;
  @Input() heading?: string = "No Data Found!";
  @Input() description?: string = `It seems there's nothing to display here. Try adjusting your filters or check back later.`;
  @Input() heading1?: string = "No Content Pool Found!";
  @Input() title?: string = "content pool";


  @Output() createNewClick = new EventEmitter<void>();

  createNew() {
    this.createNewClick.emit();
  }

}
